import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const columnTextFilterProps = (dataIndex, name) => {
  let inputTimer = null;
  let dropdownArgs = {};
  let dropDownComponent = (
    <Input
      placeholder={`Search ${name}`}
      value={dropdownArgs.selectedKeys && dropdownArgs.selectedKeys[0]}
      onChange={(e) => {
        dropdownArgs.setSelectedKeys(e.target.value ? [e.target.value] : []);
        delayedConfirm(dropdownArgs.confirm, 300);
      }}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
  );

  return {
    filterDropdown: (args) => {
      dropdownArgs = args;
      return <div style={{ padding: 8 }}>{dropDownComponent}</div>;
    },
    dropDownComponent: dropDownComponent,
  };

  function delayedConfirm(cb, timeout) {
    clearTimeout(inputTimer);
    inputTimer = setTimeout(cb, timeout);
  }
};
